import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface DeleteIconProps extends SvgIconProps {}

export const DeleteIcon = (props: DeleteIconProps): ReactElement => {
  return (
    <SvgIcon {...props} viewBox="0 0 30 31">
      <mask
        id="mask0_1900_3191"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="31"
      >
        <rect y="0.5" width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1900_3191)">
        <path
          d="M9.51937 25.5001C8.96 25.5001 8.48354 25.3035 8.09 24.9101C7.69667 24.5166 7.5 24.0401 7.5 23.4808V8.00014H6.25V6.75014H11.25V5.78857H18.75V6.75014H23.75V8.00014H22.5V23.4808C22.5 24.0562 22.3073 24.5366 21.9219 24.922C21.5365 25.3074 21.056 25.5001 20.4806 25.5001H9.51937ZM21.25 8.00014H8.75V23.4808C8.75 23.7051 8.82208 23.8895 8.96625 24.0339C9.11063 24.1781 9.295 24.2501 9.51937 24.2501H20.4806C20.6731 24.2501 20.8495 24.17 21.0097 24.0098C21.1699 23.8496 21.25 23.6733 21.25 23.4808V8.00014ZM12.2597 21.7501H13.5097V10.5001H12.2597V21.7501ZM16.4903 21.7501H17.7403V10.5001H16.4903V21.7501Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};
